import { object, string, array } from 'yup';

export const newWarehouseValidationScheme = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
    venueIds: array().min(1, 'At least one venue should be picked')
});